<template>
  <v-footer
    color="transparent"
    class="d-flex-column justify-center align-center"
  >
    <v-col cols="12" sm="6">
      <ul class="d-none" >
        <li v-for="route in routes" :key="route.name">
          <router-link :to="{ name: route.name }">{{ route.tag }}</router-link>
        </li>
      </ul>
      <!-- <v-divider></v-divider> -->
      <div class="my-2 small">
        <span class="d-block text-center small text-capitalize">
          Made by
          <a
            href="https://www.linkedin.com/in/adeoye-ao"
            class="px-1 small"
            id="backlink"
            ><!-- ᗪ尺丨乙乙ㄥ乇丂 -->
            Ọpẹ́olúwa </a
          >with<v-icon
            large
            color="var(--red)"
            style="font-size: 18px"
            class="ma-2"
            >mdi-heart</v-icon
          >
        </span>
      </div>
    </v-col>
  </v-footer>
</template>


<script>
export default {
  data: () => ({
    routes: [
      {
        tag: "privacy policy",
        url: "privacy-policy",
        name: "privacy-policy",
      },
      {
        tag: "terms of use",
        url: "cookie-policy",
        name: "cookie-policy",
      },
      {
        tag: "contact us",
        url: "contact",
        name: "contact",
      },
    ],
  }),
};
</script>

<style scoped>
footer {
  margin-top: 2vh;
  vertical-align: baseline !important;
  font-size: 75%;
  padding: 10vh 1.3px 0;
  box-sizing: border-box !important;
  color: var(--grey);
}

ul {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 3px;
}

ul li:first-child {
  list-style: none;
}

ul li:nth-child(2) {
  margin: 0 20.5px;
}

a,
span,
ul li a {
  text-decoration: none;
  color: var(--black);
  text-transform: capitalize;
}
a#backlink {
  color: var(--purple);
}

/* .v-footer {
  position:absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
} */
</style>
